export const A = {
  SET_PRELOADING_STATE: 'SET_PRELOADING_STATE',
  SET_PAGINATION_PER_PAGE_VALUE: 'SET_PAGINATION_PER_PAGE_VALUE',
};

export const setPreloadingState = (status) => {
  return {
    type: A.SET_PRELOADING_STATE,
    status,
  };
};

export const setPaginationPerPageValue = (data) => {
  return {
    type: A.SET_PAGINATION_PER_PAGE_VALUE,
    data,
  };
};
